// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IV2ScrollSynchronizationRequestSchema {
  /** Фильтр для синхронизации чатов **/
  filterBy?: EFilterBy;
  /** Количество запрашиваемых чатов **/
  limit: number;
  /**
   *
   *     dateTimeForSorting последнего синхронизированного чата в формате ISO-8601, YYYY-MM-DDThh:mm:ssZ.
   *     Для первой страницы отправляем текущее время в UTC.
   *
   */
  minDatetimeForSorting?: string;
  /** Раздел чатов **/
  status: EStatus;
  /**
   *
   *     Если передан этот параметр, то будут возвращены чаты для переданного суб-агента (сотрудника).
   *     Конечно только в том случае, если текущий пользователь, прошедший аутентификация,
   *     является мастером для это переданного суб-агента.
   *
   */
  subAgentRealtyUserId?: number;
}

export enum EFilterBy {
  /** Чаты с реальными пользователями (исключая ботов и системных пользователей) **/
  'Personal' = 'personal',
  /** Чаты помеченные как важные пользователем **/
  'Starred' = 'starred',
  /** Чаты с непрочитанными сообщениями **/
  'Unread' = 'unread',
}
export enum EStatus {
  /** Чат в списке всех сообщений **/
  'Active' = 'active',
  /** Чат в архиве **/
  'Archived' = 'archived',
  /** Заблокированный чат (перемещенный в спам) **/
  'Blocked' = 'blocked',
  /** Удаленный чат **/
  'Deleted' = 'deleted',
}
